//@ts-ignore
import SCSS from './../../styles/settings/animation.scss';

const animGetTime = (s:string) => {
  if(s.endsWith('ms')) {
    return parseFloat(s);
  } else if(s.endsWith('s')) {
    return parseFloat(s) * 1000;
  }
  return 200;
}

export const ANIMATION_SETTINGS:{
  easeIn:string;
  easeInOut:string;
  easeOut:string;

  timeDefault:string;
  med:string;
  short:string;
  slow:string;

  durationDefault:number;
  durationMedium:number;
  durationShort:number;
  durationSlow:number;
} = {
  //@ts-ignore
  ...SCSS,
  durationDefault: animGetTime(SCSS.timeDefault),
  durationMedium: animGetTime(SCSS.med),
  durationShort: animGetTime(SCSS.short),
  durationSlow: animGetTime(SCSS.slow),
}